import React from "react"

export default ({ dodone }) => {
  if(!dodone || !dodone.isIgnored) return null

  return <div className="red-transparent-box p-d text-sm"> Ignored </div>
}
